export default {
  subscriptionTiers: (state) => state.subscriptionTiers,
  subscriptionTier: (state) => state.subscriptionTier,
  loading: (state) => state.loading,
};

